import axios from "axios";
import { host } from "./utilities";

export const listLedgerTransactionsAxios = (ledgerUuid) => (config) =>
  axios.get(`${host()}/ledger/${ledgerUuid}/transactions`, config);
export const getLedgerAxios = (ledgerUuid) => (config) => axios.get(`${host()}/ledger/${ledgerUuid}`, config);
